import { render, staticRenderFns } from "./WorkDetail11.vue?vue&type=template&id=20b966e9&scoped=true&"
import script from "./WorkDetail11.vue?vue&type=script&lang=js&"
export * from "./WorkDetail11.vue?vue&type=script&lang=js&"
import style0 from "./WorkDetail11.vue?vue&type=style&index=0&id=20b966e9&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20b966e9",
  null
  
)

export default component.exports